import {
  GET_LOCALSTORAGE_AUTH,
  SET_LOCALSTORAGE_AUTH,
  REMOVE_LOCALSTORAGE_AUTH,
} from '../actions/types';

const initialState = {
  token: null,
  user: {},
};

const auth = (state = initialState, action) => {
  // console.log('state', state);
  // console.log('action', action);
  switch (action.type) {
    case SET_LOCALSTORAGE_AUTH:
    case GET_LOCALSTORAGE_AUTH:
      return action.payload || false;
    case REMOVE_LOCALSTORAGE_AUTH:
      return action.payload;
    default:
      return state;
  }
};

export default auth;
